// extracted by mini-css-extract-plugin
var _1 = "SeoLinks-module__container___D0FTF";
var _2 = "SeoLinks-module__divider___ntsjY";
var _3 = "SeoLinks-module__linkSection___Hl1FL";
export { _1 as "container", _2 as "divider", _3 as "linkSection" }
